export const assertUnreachable = (x: never): void => {
  //
};
export const assertIs = <T extends unknown>(x: T) => {
  //
};
